import { EconomicCalendar } from '@/components/EconomicCalendar';

const economicCalendar = new EconomicCalendar();

document.addEventListener('DOMContentLoaded', function () {
  setInterval(() => {
    const events = document.querySelectorAll('[id ^= "event-"]');
    const lastAnnounced = document.querySelector('.last-announced');
    const nextEvent = document.querySelector('.next');
    events.forEach((el) => {
      economicCalendar.updateTimeLeft(document.getElementById(el.id));
    });
    const pastEvents = document.querySelectorAll('.past');
    if (pastEvents.length > 0) {
      if (
        pastEvents[pastEvents.length - 1] &&
        pastEvents.length < events.length
      ) {
        if (lastAnnounced) {
          lastAnnounced.classList.remove('last-announced');
        }
        if (nextEvent) {
          nextEvent.classList.remove('next');
        }
        events[pastEvents.length].classList.add('next');
        pastEvents[pastEvents.length - 1].classList.add('last-announced');
      }
    }
  }, 5000);
});

document.querySelector('.date-switcher-left').addEventListener('click', () => {
  const previousDate = document.querySelector('.date.active').previousSibling;
  if (previousDate.classList.contains('date')) {
    document
      .querySelectorAll('.date')
      .forEach((obj) => obj.classList.remove('active'));
    previousDate.classList.add('active');
    economicCalendar.loadEconomicCalendar(
      previousDate.dataset.startts,
      previousDate.dataset.endts
    );
  } else {
    economicCalendar.state.headerCount++;
    const tsList = economicCalendar.buildHeader(
      economicCalendar.state.headerCount
    );
    economicCalendar.loadEconomicCalendar(tsList.startts, tsList.endts);
  }
});

document.querySelector('.date-switcher-right').addEventListener('click', () => {
  const nextDate = document.querySelector('.date.active').nextSibling;
  if (nextDate.classList && nextDate.classList.contains('date')) {
    document
      .querySelectorAll('.date')
      .forEach((obj) => obj.classList.remove('active'));
    nextDate.classList.add('active');
    economicCalendar.loadEconomicCalendar(
      nextDate.dataset.startts,
      nextDate.dataset.endts
    );
  } else if (economicCalendar.state.headerCount != 0) {
    economicCalendar.state.headerCount = --economicCalendar.state.headerCount;
    const tsList = economicCalendar.buildHeader(
      economicCalendar.state.headerCount
    );
    economicCalendar.loadEconomicCalendar(tsList.startts, tsList.endts);
  }
});

const btnFilterImpact = document.querySelectorAll('.js-filter-impact');
btnFilterImpact.forEach((el) =>
  el.addEventListener('click', () => {
    economicCalendar.state.filter.impact = el.dataset.impact;
    economicCalendar.filterEvents();
  })
);

economicCalendar.buildHeader(0, 1);
economicCalendar.joinEconomicCalendar();
